
import React from 'react';
import { formatDate, formatDateWithTime } from '../../constants/DateUtil/DateUtil';
import { getStoreLocalData } from '../../utils/localStorage';

const PaymentCollectionOrderInfoCard = ({customerOrdersData}) => {

  const { storeLocalData } = getStoreLocalData();
  const orderDetails = customerOrdersData;
  const orderInfoDetails = {
    orderNo: orderDetails?.orderNo ? orderDetails?.orderNo : 'N/A',
    invoiceNo: orderDetails?.invoiceNo ? orderDetails?.invoiceNo : 'N/A',
    grandTotal: orderDetails?.grandTotal ? orderDetails?.grandTotal : 0,
    paidAmount: orderDetails?.paidAmount ? orderDetails?.paidAmount : 0,
    gstAmount: orderDetails?.gstAmount ? orderDetails?.gstAmount : 0,
    balanceAmount: orderDetails?.balanceAmount
      ? orderDetails?.balanceAmount
      : 0,
    deliveryOn: orderDetails?.deliveryOn ? orderDetails?.deliveryOn : 'N/A',
    deliveredOn: orderDetails?.deliveredOn ? orderDetails?.deliveredOn : 'N/A',
    status: orderDetails?.status ? orderDetails?.status : 'N/A',
    chargeAmount: orderDetails?.chargeAmount
      ? orderDetails?.chargeAmount + orderDetails?.totalDeliveryCharge
      : 0,
    deliveryRequest: orderDetails?.deliveryRequest === true ? 'Yes' : 'No',
    discountAmount:
      orderDetails?.discountAmount +
      orderDetails?.totalDeliveryDiscount +
      orderDetails?.offerDiscount +
      orderDetails?.subscriptionDiscount,
    createdDate: orderDetails?.createdDate
      ? orderDetails?.createdDate
      : '2023-11-17T12:26:36Z',
  };

  const displayDeliveryDateText =
    orderInfoDetails.status === 'DELIVERED' ||
    orderInfoDetails.status === 'DONE'
      ? 'Delivered On'
      : 'Delivery Date';
  const displayDate =
    orderInfoDetails.status === 'DELIVERED' ||
    orderInfoDetails.status === 'DONE'
      ? orderInfoDetails.deliveredOn
      : orderInfoDetails.deliveryOn;

  const formattedCreatedDate = formatDateWithTime(orderInfoDetails.createdDate);
  const formattedDeliveredOnDate = formatDate(displayDate);

  return (
    <div className="flex-1 ">
      <div className="m-4 shadow-4">
        <div className="flex flex-1">
          <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}>
            <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Order No. :</p>
            <p className="text-lg font-medium capitalize">
              {orderInfoDetails.orderNo}
            </p>
          </div>
          <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}>
            <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Home Delivery :</p>
            <p className="text-lg font-medium capitalize">
              {orderInfoDetails.deliveryRequest}
            </p>
          </div>
        </div>
        <div className="flex flex-1">
          <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}>
            <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Invoice No. :</p>
            <p className="text-lg font-medium capitalize">
              {orderInfoDetails.invoiceNo}
            </p>
          </div>
          <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}>
            <div className="flex flex-row justify-content-between">
              <div>
                <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Amt Info :</p>
                <p className="text-lg font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.grandTotal}
                </p>
              </div>
              <div>
                <p className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}>{storeLocalData?.taxType} Info :</p>
                <p className="text-lg font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.gstAmount}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-1">
          <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}>
            <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Paid Info :</p>
            <p className="text-lg font-medium capitalize">
              {storeLocalData?.currencySymbol} {orderInfoDetails.paidAmount}
            </p>
          </div>
          <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}>
            <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Balance Amt :</p>
            <p className="text-lg font-medium capitalize">
              {storeLocalData?.currencySymbol} {orderInfoDetails.balanceAmount}
            </p>
          </div>
        </div>
        <div className="flex flex-1">
          <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}>
            <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Booking Date :</p>
            <p className="text-lg font-medium capitalize">{formattedCreatedDate}</p>
          </div>
          <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}>
            <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>
              {displayDeliveryDateText} :
            </p>
            <p className="text-lg font-medium capitalize">
              {formattedDeliveredOnDate}
            </p>
          </div>
        </div>
        {(orderInfoDetails.discountAmount > 0 ||
          orderInfoDetails.chargeAmount > 0) && (
          <div className="flex flex-1">
            <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}>
              <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Charge :</p>
              <p className="text-lg font-medium capitalize">
                {storeLocalData?.currencySymbol} {orderInfoDetails.chargeAmount}
              </p>
            </div>
            <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}>
              <div className="flex flex-row justify-content-between">
                <div>
                  <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Discount</p>
                  <p className="text-lg font-medium capitalize">
                    {storeLocalData?.currencySymbol} {orderInfoDetails.discountAmount}
                  </p>
                </div>
                {orderDetails?.subscriptionDiscount > 0 &&
                  orderDetails?.appliedSubscriptionDiscount === false && (
                    <div>
                      <p
                        className="text-md font-medium capitalize"
                        style={{ color: "red" }}>
                        * T&C Applied
                      </p>
                    </div>
                  )}
              </div>
            </div>
          </div>
        )}
        {orderInfoDetails.editBy && (
          <div className="flex flex-1">
            <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}>
              <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>Edited By :</p>
              <p className="text-lg font-medium capitalize">
                {orderInfoDetails.editBy}
              </p>
            </div>
            <div className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}>
              <p className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}>
                Last Modification Date :
              </p>
              <p className="text-lg font-medium capitalize">
                {formattedDeliveredOnDate}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentCollectionOrderInfoCard;